// extracted by mini-css-extract-plugin
module.exports = {"details":"MaterialValueDetails_details__12nm1"};